import createIconComponent from './utils/createIconComponent';
import React from 'react';
const CorrectSquareSolid = createIconComponent({
  height: 30,
  width: 30,
  content: (
    <g>
      <rect height='30' width='30.49955' />
      <path
        fill='#efefef'
        d='m21.4199,7.93175c0.6819,0.58003 0.7709,1.60047 0.1997,2.28985l-7.1654,8.6479c-0.5748,0.6936 -1.5942,0.7876 -2.2831,0.2105l-3.58022,-2.9994c-0.68788,-0.5763 -0.78474,-1.5985 -0.21735,-2.2938c0.57782,-0.708 1.62291,-0.807 2.32343,-0.2201l2.30324,1.9296l6.1001,-7.36219c0.5817,-0.70204 1.6251,-0.79307 2.3196,-0.20236z'
      />
    </g>
  ),
});
CorrectSquareSolid.displayName = 'CorrectSquareSolid';
export default CorrectSquareSolid;
